import Lang from './LanguageSwitcher'

export default Lang